import React, { useEffect, useState } from "react";
import { Heart, Loader2, Globe, BookOpen, Settings, X } from "lucide-react";
import fortyTwoCoursesLogo from "./images/42courses.png";
import cannesLionsLogo from "./images/cannes-lion.png";
import "./style.scss";
import { getRequest } from "../../utils/httpRequest";
import { AxiosResponse } from "axios/index";

export function CannesReviews() {
  const [testimonial, setTestimonial] = useState(null);
  const [animating, setAnimating] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleGenerate = () => {
    setLoading(true);
    setAnimating(true);

    const getReview = () => {
      getRequest("/api/pages/cannes_reviews.json")
        .then((response: AxiosResponse) => {
          setTestimonial(response.data);
        })
        .catch((e) => console.log(e))
        .finally(() => {
          setLoading(false);
          setAnimating(false);
        });
    };

    setTimeout(getReview, 400);
  };
  return (
    <div className="cannes-reviews">
      <div className="cannes-reviews app">
        <header className="app__header">
          <div className="header__logo-group">
            <img
              src={fortyTwoCoursesLogo}
              alt="42courses"
              className="header__logo header__logo--inverted"
            />
            <span className="header__divider">|</span>
            <img
              src={cannesLionsLogo}
              alt="Cannes Lions"
              className="header__logo header__logo--inverted"
            />
          </div>
        </header>
        {/* Main Content */}
        <main className="app__main">
          {!testimonial ? (
            <div className="intro">
              <h1 className="intro__title">Feel the Love</h1>
              <p className="intro__subtitle">
                See what our amazing community has to say about learning with
                Cannes Lions & 42courses.
              </p>
            </div>
          ) : (
            <div
              className={`testimonial-card ${animating ? "testimonial-card--animating" : ""}`}
            >
              <h2 className="testimonial-card__quote">
                "{testimonial.content}"
              </h2>
              <div className="testimonial-card__footer">
                <div className="testimonial-card__author">
                  {testimonial.profile_picture ? (
                    <img
                      src={testimonial.profile_picture}
                      alt="42courses"
                      className="testimonial-card__avatar"
                    />
                  ) : (
                    <div className="testimonial-card__avatar">
                      "{testimonial.username?.charAt(0)}"
                    </div>
                  )}
                  <div className="testimonial-card__details">
                    <p className="testimonial-card__name">{testimonial.name}</p>
                    <div className="testimonial-card__meta">
                      <Globe size={12} /> {testimonial.country_name}
                    </div>
                  </div>
                </div>
                <div className="testimonial-card__course-badge">
                  <BookOpen size={16} />
                  {testimonial.course_name}
                </div>
              </div>
            </div>
          )}
          <div className="action-area">
            <div className="action-area__glow"></div>
            <button className="btn" onClick={handleGenerate} disabled={loading}>
              {loading ? (
                <Loader2 className="btn__icon btn__icon--spin" />
              ) : (
                <>
                  <Heart
                    className={`btn__icon ${testimonial ? "btn__icon--filled" : ""}`}
                  />
                  Show me Love
                </>
              )}
            </button>
          </div>
        </main>

        <footer className="app__footer">
          <p>
            Made with{" "}
            <Heart
              size={12}
              style={{ display: "inline", color: "red", fill: "red" }}
            />{" "}
            for Cannes Lions
          </p>
          <button className="footer-link">
            <Settings size={12} /> Admin
          </button>
        </footer>
      </div>
    </div>
  );
}
